var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"people-describe"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.data.image}})]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.text))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672b19e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageEditor/modules/peopleDescribe.vue
// module id = null
// module chunks = 